module.exports = __webpack_public_path__ + "img/page.00273471.png";